<template>
  <el-main>
    <h3 class="section-title green-left-head">申込割付管理</h3>
    <el-descriptions title="基本情報" :column="1">
      <el-descriptions-item label="名称">{{
        allocation.name
      }}</el-descriptions-item>
      <el-descriptions-item label="タイプ">{{
        allocation.type
      }}</el-descriptions-item>
      <el-descriptions-item label="期間"
        >{{ $date(allocation.reception_range[0]).tz().format("YYYY-MM-DD") }} 〜
        {{
          $date(allocation.reception_range[1]).tz().format("YYYY-MM-DD")
        }}</el-descriptions-item
      >
    </el-descriptions>
    <el-divider></el-divider>
    <el-button @click="dialogVisible = true">割付ブロックを確認する</el-button>
    <el-button @click="downloadCSV">ダウンロード</el-button>
    <el-divider></el-divider>
    <el-tabs
      v-model="no"
      @tab-click="onSelectCarNo"
      v-if="allocation.type != 'フリー'"
    >
      <el-tab-pane label="1台目"></el-tab-pane>
      <el-tab-pane label="2台目"></el-tab-pane>
      <el-tab-pane label="3台目"></el-tab-pane>
    </el-tabs>
    <el-divider></el-divider>
    <el-table
      :data="resultsByRoom[no]"
      stripe
      style="width: 100%"
      max-height="500"
    >
      <el-table-column
        label="部屋番号"
        prop="roomNo"
        width="100"
        sortable
        fixed
      ></el-table-column>
      <el-table-column
        label="優先順位"
        prop="entry.priority"
        width="100"
        sortable
        fixed
      ></el-table-column>
      <el-table-column
        label="ブロック"
        prop="block"
        width="100"
        sortable
        fixed
      ></el-table-column>
      <el-table-column
        label="番号"
        prop="label"
        width="100"
        sortable
        fixed
      ></el-table-column>
      <el-table-column
        v-for="(block, index) in blocks[no]"
        :key="index"
        :label="index"
        :prop="index"
        sortable
      >
        <template slot-scope="scope">
          <div v-if="scope.row.entry != null && scope.row.entry[index]">
            <div v-if="scope.row.entry[index] < 99999">
              {{ scope.row.entry[index] }}
            </div>
            <div v-else-if="scope.row.entry[index] == 99999">不要</div>
            <div v-else-if="scope.row.entry[index] == 999999">不可</div>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="割付ブロック" :visible.sync="dialogVisible" width="80%">
      <el-table
        :data="resultsByBlock"
        stripe
        style="width: 100%"
        max-height="500"
      >
        <el-table-column
          label="ブロック"
          prop="block"
          width="100"
        ></el-table-column>
        <el-table-column label="割付ブロック" prop="rooms"
          ><template slot-scope="scope">
            {{ scope.row.rooms.join(",") }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-divider></el-divider>
    <el-button @click="$router.go(-1)">戻る</el-button>
    <el-button @click="$router.push({ name: `admin-allocation-index` })"
      >一覧に戻る</el-button
    >
  </el-main>
</template>

<script>
import AllocationService from "../../../../services/allocation.service";
import AllocationLotteryService from "../../../../services/allocation-lottery.service";
import AllocationAreaService from "../../../../services/allocation-area.service";
import Admin from "../../../../mixin/guard/admin";
import _ from "lodash";
import UserService from "@/services/user.service";
import dayjs from "@/libs/day.js";

export default {
  mixins: [Admin],
  data() {
    return {
      allocation: { reception_range: [dayjs().toDate(), dayjs().toDate()] },
      lottery: {},
      blocks: [[], [], []],
      // results: [{}, {}, {}],
      resultsByRoom: [[], [], []],
      resultsByBlock: [],
      blockResults: {},
      users: [],
      no: "0",
      dialogVisible: false
    };
  },
  async mounted() {
    // マンションの住人を取得
    await this.loadUsersInMansion();
    // Allocationの取得
    await this.loadAllocation(this.$route.params.allocation_id);
    // AllocationAreaの取得
    await this.loadAllocationArea(this.$route.params.allocation_id);
    // AllocationLotteryの取得
    await this.loadLotteryByAllocationID(this.$route.params.allocation_id);
    // this.initResults();
    this.initBlockResult();
    await this.onLottery();
    this.initResultsByRoomNo();
    this.initResultsByBlock();
  },
  methods: {
    resultsByRoom2CSV() {
      console.log("resultsByRoom2CSV", this.resultsByRoom);
      let data = `抽選結果\n${this.mansion.name}\n${this.allocation.name}\n`;
      let header = "部屋番号,優先順位,ブロック,番号";
      const block = this.blocks[0];
      for (const key in block) {
        if (Object.hasOwnProperty.call(block, key)) {
          header += `,${key}`;
        }
      }
      console.log("data", data);
      if (this.allocation.type != "フリー") {
        for (let index = 0; index < this.resultsByRoom.length; index++) {
          data += `\n${index + 1}台目`;
          data += `\n${header}`;
          const element = this.resultsByRoom[index];
          console.log("element", element);
          for (let index2 = 0; index2 < element.length; index2++) {
            const element2 = element[index2];
            data += `\n${element2.roomNo},${element2.entry.priority ?? ""},${
              element2.block
            },${element2.label}`;
            for (const key in block) {
              if (Object.hasOwnProperty.call(block, key)) {
                const value = element2.entry[key];
                if (value) {
                  let str = value;
                  if (str == 99999) {
                    str = "不要";
                  } else if (str == 999999) {
                    str = "不可";
                  }
                  data += `,${str}`;
                } else {
                  data += `,`;
                }
              }
            }
          }
          data += `\n`;
        }
      } else {
        data += `\n${header}`;
        const element = this.resultsByRoom[0];
        console.log("element", element);
        for (let index2 = 0; index2 < element.length; index2++) {
          const element2 = element[index2];
          data += `\n${element2.roomNo},${element2.entry.priority ?? ""},${
            element2.block
          },${element2.label}`;
          for (const key in block) {
            if (Object.hasOwnProperty.call(block, key)) {
              const value = element2.entry[key];
              if (value) {
                let str = value;
                if (str == 99999) {
                  str = "不要";
                } else if (str == 999999) {
                  str = "不可";
                }
                data += `,${str}`;
              } else {
                data += `,`;
              }
            }
          }
        }
        data += `\n`;
      }

      console.log("data", data);
      return data;
    },
    downloadCSV() {
      console.log("downloadCSV");
      //ダウンロードするCSVファイル名を指定する
      const filename = `抽選結果_${this.mansion.name}_${
        this.allocation.name
      }_${this.$date().tz().format("YYYY-MM-DD_HH:mm:ss")}.csv`;
      //CSVデータ

      const data = this.resultsByRoom2CSV();
      //BOMを付与する（Excelでの文字化け対策）
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      //Blobでデータを作成する
      const blob = new Blob([bom, data], { type: "text/csv" });

      //IE10/11用(download属性が機能しないためmsSaveBlobを使用）
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, filename);
        //その他ブラウザ
      } else {
        //BlobからオブジェクトURLを作成する
        const url = (window.URL || window.webkitURL).createObjectURL(blob);
        //ダウンロード用にリンクを作成する
        const download = document.createElement("a");
        //リンク先に上記で生成したURLを指定する
        download.href = url;
        //download属性にファイル名を指定する
        download.download = filename;
        //作成したリンクをクリックしてダウンロードを実行する
        download.click();
        //createObjectURLで作成したオブジェクトURLを開放する
        (window.URL || window.webkitURL).revokeObjectURL(url);
      }
    },
    onSelectCarNo() {
      console.log("onSelectCarNo", this.no);
    },
    // マンションの住人を取得
    async loadUsersInMansion() {
      console.log("loadUsersInMansion");
      const response = await UserService.findAtMansion({
        option: {
          sort: { roomNo: 1 },
          select: "roomNo",
        },
        collation: {
          locale: "en",
          numericOrdering: true,
        },
      });
      this.users = response.data;
      console.log("this.users", this.users);
    },
    initBlockResult() {
      console.log("initBlockResult");
      console.log("this.blocks :>> ", this.blocks);
      this.blockResults = {};
      const no = 0;
      // for (let no = 0; no < 3; no++) {
      // const obj = {};
      for (const key in this.blocks[no]) {
        if (Object.hasOwnProperty.call(this.blocks[no], key)) {
          const element = this.blocks[no][key];
          console.log("element", element);
          // for (const key2 in element.no) {
          //   if (Object.hasOwnProperty.call(element.no, key2)) {
          //     const element2 = element.no[key2];
          //     // obj[key][element2] = null;
          _.set(
            this.blockResults,
            `${key}`,
            Array(element.no.length).fill(null)
          );
          // }
        }
        // }
      }

      console.log("this.blockResults :>> ", this.blockResults);
    },
    // 割り当て済みを削除
    diffBlock(no) {
      console.log("diffBlock");
      console.log("no", no);
      console.log("blocks", this.blocks);
      console.log("results", this.results);
      if (no == 0) {
        return;
      }
      const lastBlock = this.blocks[no - 1];
      console.log("lastBlock", lastBlock);
      const lastResults = this.results[no - 1];
      console.log("lastResults", lastResults);
      this.blocks[no] = _.cloneDeep(lastBlock);
      // 当選済みの部屋番号を取得する
      for (const key in lastResults) {
        if (Object.hasOwnProperty.call(lastResults, key)) {
          const block = lastResults[key];
          console.log("element", block);
          let removeNos = [];
          for (const key2 in block) {
            if (Object.hasOwnProperty.call(block, key2)) {
              const value = block[key2];
              if (value) {
                console.log("key2", key2);
                removeNos.push(key2);
              }
            }
          }
          console.log("removeNos", removeNos);
          console.log(
            "1this.blocks[no][key]",
            _.cloneDeep(this.blocks[no][key])
          );
          this.blocks[no][key].no = this.blocks[no][key].no.filter(
            (item) => !removeNos.includes(item)
          );
          console.log(
            "2this.blocks[no][key]",
            _.cloneDeep(this.blocks[no][key])
          );
        }
      }

      console.log("out:diffBlock", no, _.cloneDeep(this.blocks));
    },
    // Allocationの取得
    async loadAllocation(allocation_id) {
      console.log("loadAllocation");
      const response = await AllocationService.findByID(allocation_id);
      this.allocation = response.data;
      console.log(this.allocation);
    },
    async loadLotteryByAllocationID(allocation_id) {
      console.log("loadLotteryByAllocationID", allocation_id);
      const response = await AllocationLotteryService.find({
        where: {
          allocation: allocation_id,
        },
      });
      if (response.data && response.data.length > 0) {
        this.lottery = response.data[0];
      }
      console.log("this.lottery", this.lottery);

    },
    initResults() {
      console.log("initResults");
      for (let index = 0; index < 3; index++) {
        this.results[index] = {};
        for (const key in this.blocks[index]) {
          if (Object.hasOwnProperty.call(this.blocks[index], key)) {
            const block = this.blocks[index][key];
            this.results[index][key] = {};
            for (let index2 = 0; index2 < block.no.length; index2++) {
              const no = block.no[index2];
              this.results[index][key][no] = null;
            }
          }
        }
      }

      console.log("results=", this.results);
    },
    onLottery: async function () {
      console.log("onLottery");
      console.log("blockResults:before", _.cloneDeep(this.blockResults));
      // console.clear();

      console.log("this.normalizedEntries", this.lottery);
      console.log("this.blocks", this.blocks);
      // 各ブロックの当選順位を決める
      const blockNames = Object.keys(this.blocks[0]);
      console.log("blockNames", blockNames);

      let winnerCounter = {};
      // 車の台数分回す
      for (let no = 0; no < 3; no++) {
        const normalizedEntries = this.lottery.normalizedEntries[no];
        console.log("normalizedEntries", no, normalizedEntries);
        // priorityが存在するものを取得し、priorityでソートする
        const sortedEntries = normalizedEntries
          .filter((item) => {
            return item.priority != null;
          })
          .sort((a, b) => {
            return a.priority - b.priority;
          });
        console.log("sortedEntries :>> ", sortedEntries);
        for (
          let sortedIndex = 0;
          sortedIndex < sortedEntries.length;
          sortedIndex++
        ) {
          const entry = sortedEntries[sortedIndex];
          console.log("entry", entry, entry.priority);
          // entryのブロックを配列化する
          let entryBlocks = [];
          for (
            let blockIndex = 0;
            blockIndex < blockNames.length;
            blockIndex++
          ) {
            const blockName = blockNames[blockIndex];
            entryBlocks.push({
              blockName: blockName,
              priority: entry[blockName],
            });
          }
          // entryのブロックをプライオリティでソートする
          entryBlocks = entryBlocks.sort((a, b) => {
            return a.priority - b.priority;
          });
          console.log("entryBlocks :>> ", entry.roomNo, entryBlocks);
          // ブロックの当選結果にentryを追加する
          entryLoop: for (
            let index3 = 0;
            index3 < entryBlocks.length;
            index3++
          ) {
            const block = entryBlocks[index3];
            console.log("block :>> ", block);
            // console.log("entry.entry >>", entry.entry);
            if (
              this.isExistNullEntry(this.blockResults[block.blockName]) &&
              block.priority != 99999 &&
              block.priority != 999999
            ) {
              console.log(
                "this.blockResults[block.blockName] :>> ",
                this.blockResults[block.blockName]
              );
              const result = this.blockResults[block.blockName];
              for (let index4 = 0; index4 < result.length; index4++) {
                const element = result[index4];
                if (element == null) {
                  const entry_no = _.get(entry, "entry.no");
                  result[index4] = {
                    roomNo: entry.roomNo,
                    no: entry_no,
                    value: entry,
                  };
                  if (winnerCounter[block.blockName] == null) {
                    winnerCounter[block.blockName] = 1;
                  } else {
                    winnerCounter[block.blockName]++;
                  }
                  break entryLoop;
                }
              }
            }
          }
        }
      }
      // console.log("result", result);
      console.log("blockResults:result", _.cloneDeep(this.blockResults));
      console.log("winnerCounter", winnerCounter);
    },
    isExistNullEntry(array) {
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if (element == null) {
          return true;
        }
      }
      return false;
    },

    initResultsByBlock() {
      console.log("initResultsByBlock", this.blockResults);
      this.resultsByBlock = [];
      for (const key in this.blockResults) {
        if (Object.hasOwnProperty.call(this.blockResults, key)) {
          const element = this.blockResults[key];
          const obj = {
            block: key,
            rooms: element.map((item) => {
              if (item) {
                return `${item.roomNo}(${item.no + 1})`;
              }
            }),
          };
          this.resultsByBlock.push(obj);
        }
      }
      console.log("resultsByBlock=", this.resultsByBlock);
    },
    initResultsByRoomNo() {
      console.log("this.users", this.users);
      console.log("this.lottery", this.lottery);
      this.resultsByRoom = [[], [], []];
      for (let no = 0; no < 3; no++) {
        const normalizedEntries = this.lottery.normalizedEntries[no];
        // console.log("normalizedEntries", normalizedEntries);
        for (let index = 0; index < normalizedEntries.length; index++) {
          // const user = this.users[index];

          const room = this.findEntryByRoomNo(
            normalizedEntries[index].roomNo,
            no
          );
          // console.log("room", room);
          const obj = {
            label: room ? room.label : "",
            roomNo: normalizedEntries[index].roomNo,
            index: index,
            block: room ? room.block : "",
            entry: normalizedEntries[index],
          };

          this.resultsByRoom[no].push(obj);
        }
      }

      console.log("resultsByRoom=", this.resultsByRoom);
    },
    getNoByBlock(block, index) {
      console.log("getNoByBlock", block, index);
      return this.blocks[0][block].no[index];
    },
    findEntryByRoomNo(roomNo, no) {
      // console.log("findEntryByRoomNo", roomNo, no);
      let result = null;
      for (const key in this.blockResults) {
        if (Object.hasOwnProperty.call(this.blockResults, key)) {
          const element = this.blockResults[key];
          // console.log("element", element);
          // const entry = element.find((item) => {
          //   return item != null && item.roomNo == roomNo && item.no == no;
          // });
          const index = element.findIndex((item) => {
            return item != null && item.roomNo == roomNo && item.no == no;
          });
          // console.log("index", index);
          if (index > -1) {
            return {
              label: this.getNoByBlock(key, index),
              index,
              entry: element[index],
              block: key,
            };
          }
        }
      }
      return result;
    },
    // initResultsByRoomNo() {
    //   this.resultsByRoom = [];
    //   for (const key in this.results[this.no]) {
    //     if (Object.hasOwnProperty.call(this.results[this.no], key)) {
    //       const element = this.results[this.no][key];
    //       for (const key2 in element) {
    //         if (Object.hasOwnProperty.call(element, key2)) {
    //           const obj = element[key2];
    //           this.resultsByRoom.push({
    //             block: key,
    //             no: key2,
    //             roomNo: obj ? obj.roomNo : "",
    //             entry: obj,
    //           });
    //         }
    //       }
    //     }
    //   }
    //   console.log("resultsByRoom=", this.resultsByRoom);
    // },
    async loadAllocationArea(allocation_id) {
      console.log("loadAllocationArea", allocation_id);
      const response = await AllocationAreaService.find({
        allocation: allocation_id,
      });
      const areas = response.data;
      console.log("areas", areas);


      this.blocks = [{}, {}, {}];
      for (let index = 0; index < areas.length; index++) {
        const area = areas[index];
        // console.log("area", area);
        for (let no = 0; no < 3; no++) {
          if (this.blocks[no][area.block] === undefined) {
            // console.log("+++", no, area.block);
            this.blocks[no][area.block] = {
              type: area.type,
              no: [area.no],
              length: area.length,
              width: area.width,
              height: area.height,
              weight: area.weight,
            };
          } else {
            this.blocks[no][area.block].no.push(area.no);
          }
        }
      }

      console.log("blocks", this.blocks);
    },
  },
};
</script>
../../../../mixin/guard/admin
